module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }